/* === CPB: Global redirect (<quantity-input> or [data-cpb-redirect]) === */
(function () {
  if (window.__CPB_CART_REDIRECT__) return;
  window.__CPB_CART_REDIRECT__ = true;

  /* Build redirect URL with configid + modifyProduct */
  const buildUrl = (base, configId, productId) => {
    if (!base || !configId || !productId) return null;
    const sep = base.includes('?') ? '&' : '?';
    return `${base}${sep}configid=${encodeURIComponent(configId)}&modifyProduct=${encodeURIComponent(productId)}`;
  };

  /* Main click handler (works in DOM and Shadow DOM) */
  const handleClick = (e) => {
    const container =
      e.target.closest?.('quantity-input') ||
      e.target.closest?.('[data-cpb-redirect]');

    if (!container) return;

    const { productUrl, configId, productId } = container.dataset;
    if (!productUrl || !configId || !productId) return;

    e.preventDefault();
    e.stopPropagation();

    const url = buildUrl(productUrl, configId, productId);
    if (url) window.location.href = url;
  };

  /* Attach event listeners to normal DOM */
  const attachDOMListeners = () => {
    document.addEventListener('pointerdown', handleClick, true);
    document.addEventListener('click', handleClick, true);
  };

  /* Attach event listeners to Upcart Shadow DOM */
  const attachShadowListeners = () => {
    const host = document.querySelector('#upCart');
    if (!host || !host.shadowRoot) return;

    const shadow = host.shadowRoot;

    if (shadow.__cpbListenerAttached) return; // prevent double-binding
    shadow.__cpbListenerAttached = true;

    shadow.addEventListener('pointerdown', handleClick, true);
    shadow.addEventListener('click', handleClick, true);

    console.debug('[CPB Redirect] Shadow-root listener attached');
  };

  /* Watch for Upcart being loaded dynamically */
  const startShadowWatcher = () => {
    const tryAttach = () => {
      attachShadowListeners();
    };
    // runs periodically because Upcart re-renders shadow DOM
    setInterval(tryAttach, 300);
  };

  /* Init all */
  const init = () => {
    attachDOMListeners();
    startShadowWatcher();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
